export const USER_CART_REQUEST = "USER_CART_REQUEST"
export const USER_CART_SUCCESS = "USER_CART_SUCCESS"
export const USER_CART_FAIL = "USER_CART_FAIL"

export const ADD_CART_REQUEST = "USER_CART_REQUEST"
export const ADD_CART_SUCCESS = "USER_CART_SUCCESS"
export const ADD_CART_FAIL = "USER_CART_FAIL"